/* eslint-disable max-len */
import { Grid, List, makeStyles, Typography } from '@material-ui/core';
import { useRef, useState } from 'react';
import commonTheme from '../../styles/theme';
import CustomerInfoSp from '../../common/customer/customerInfo/customerInfoSp';
import { useLoading } from '../../../hooks';
import { LINE_RECEPTION } from '../../../constants/loading';
import ListItemComponent from './parts/listItemComponent';

const useStyles = makeStyles({
  wrap: {
    [commonTheme.breakpoints.up('md')]: {
      height: '100%',
      position: 'relative',
    },
    [commonTheme.breakpoints.down('sm')]: {
      height: '100%',
      '& .ptr': {
      },
      '& .ptr__pull-down': {
        top: 0,
      },
    },
  },
  noData: {
    paddingTop: '50px',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lineReceptions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    overflowY: 'auto',
    minHeight: 'auto',
  },
});

function LineReceptionComponent(props) {
  const {
    lineReceptions,
  } = props;
  const classes = useStyles();
  const { hasLoading } = useLoading();

  // モーダル開閉
  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(!open);
  };
  const [customerId, setCutstomerId] = useState('');
  const element = useRef(null);

  /**
   * LINE受信一覧を表示する
   */
  function renderList() {
    if (!lineReceptions?.length && !hasLoading(LINE_RECEPTION)) {
      return (
        <Typography className={classes.noData}>
          受信履歴は存在しません
        </Typography>
      );
    }

    if (lineReceptions?.length > 0) {
      return lineReceptions.map((data) => (
        <ListItemComponent
          key={`key${data.customer.memberId}`}
          data={data}
          setOpen={setOpen}
          setCutstomerId={setCutstomerId}
        />
      ));
    }
    return null;
  }

  return (
    <Grid
      className={classes.wrap}
      ref={element}
    >
      {/* 顧客詳細表示用 */}
      {customerId && (
        <CustomerInfoSp
          open={open}
          setOpen={setOpen}
          onClose={onClose}
          customerId={customerId}
          fullScreen
        />
      )}
      <List className={classes.lineReceptions}>
        {renderList()}
      </List>
    </Grid>
  );
}

export default LineReceptionComponent;
